import React, { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import './KalpYagmuru.css';

/**
 * Her ayin 9'unda, yalnizca Beril kullanicisinin ekraninda suzulen kalpler.
 *
 * Giris sayfasindaki yildiz katmanlariyla ayni teknik: iki dokulu katman
 * farkli hiz ve olcekte kayiyor, yalnizca transform ve opacity animasyonu
 * var. Bu yuzden hicbir performans maliyeti getirmiyor ve tiklamalari
 * engellemiyor (pointer-events: none).
 *
 * Baska hicbir kullanici bunu gormez.
 */

const AYIN_GUNU = 9;
const BERIL_ID = 6;

const berilMi = (user) => {
  if (!user) return false;
  const id = user.Id ?? user.id;
  if (id === BERIL_ID) return true;
  return String(user.Username ?? user.username ?? '').toUpperCase() === 'BERIL';
};

const bugunMu = () => new Date().getDate() === AYIN_GUNU;

const KalpYagmuru = () => {
  const { user } = useAuth();
  const [gun, setGun] = useState(bugunMu);

  useEffect(() => {
    // Uygulama gece yarisini asarak acik kalirsa gun degisimini yakalar.
    const zamanlayici = setInterval(() => setGun(bugunMu()), 60 * 1000);
    return () => clearInterval(zamanlayici);
  }, []);

  if (!gun || !berilMi(user)) return null;

  return <div className="kalp-yagmuru" aria-hidden="true" />;
};

export default KalpYagmuru;
